import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { faEye, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ContributionFilter } from 'src/app/shared/classe/contribution-filter.model';
import { DeclarationType } from 'src/app/shared/enum/declaration-type';
import { ModalHistoricoContribuicaoComponent } from 'src/app/shared/modals/modal-historico-contribuicao/modal-historico-contribuicao.component';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({
  selector: 'app-historico-contribuicoes',
  templateUrl: './historico-contribuicoes.component.html',
  styleUrls: ['./historico-contribuicoes.component.css']
})
export class HistoricoContribuicoesComponent implements OnInit {
  loadingPdf: boolean = false;
  loadingCsv: boolean = false;
  //Icones    
  faPdf = faFilePdf;
  faExcel = faFileExcel;
  faEye = faEye;
  today = new Date();
  loading: boolean = false;
  downloading: boolean = false;
  myContributionRequests: any;
  formGroup: FormGroup = new FormGroup({
    finalDate: new FormControl(null),
    initialDate: new FormControl(null),
    isPaginated: new FormControl(true),
    itemsPerPage: new FormControl(5),
    page: new FormControl(1),
    totalFiltered: new FormControl(),
  });
  constructor(private socialSecurityService: SocialSecurityService, private modalService: NgbModal) {
  }
  protected getFilter() {
    this.loading = true;
    this.socialSecurityService.getPagedContributionHistory({ ...this.formGroup.value, page: this.formGroup.value.page - 1 }).subscribe((res: any) => {
      this.myContributionRequests = res;
      this.loading = false;
    })
  }
  printCsv() {
    let contributionFilter = new ContributionFilter(0, 0, this.formGroup.get('initialDate')?.value, this.formGroup.get('finalDate')?.value, 'normal');
    this.socialSecurityService.getContributionsCsv(contributionFilter).subscribe(
      (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Extrato de Contribuicoes.csv";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      });
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formGroup.value.itemsPerPage = quantidade;
    this.formGroup.value.page = 1;
    this.getFilter();
  }
  onChangePagination(page: number) {
    if (this.formGroup.value.page != page) {
      this.formGroup.value.page = page;
      this.getFilter();
    }
  }
  exportPdf() {
    this.downloading = true;
    let param = {
      type: DeclarationType.ContributionHistory
    }
    this.socialSecurityService.postContributionHistory(param).subscribe({
      next: (data: any) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Histórico de Contribuições - " + moment().format('DD_MM_YYYY') + ".pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.downloading = false;
      },
      error: (err: any) => this.downloading = false
    });
  }
  visualizarContribuicao(details: any) {
    const modalRef = this.modalService.open(ModalHistoricoContribuicaoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = details;
  }
  ngOnInit(): void {
    this.getFilter();
  }
}
